export default  {
    CLAVE_UNICA_AUTH:'CLAVE_UNICA_AUTH',
    QUESTIONS_AUTH:'QUESTIONS_AUTH',
    TRANSFERENCE_AUTH:'TRANSFERENCE_AUTH',
}